import React from 'react'
import {LabelText} from '../../Language';
import config from '../../../common/const/config'

export function RemainingCharacters({enteredCharsLength}) {
    return (
            enteredCharsLength ? <div className="remaining-char">
            <span><LabelText tid="remaining_chars" /></span><span>{config.maxCharLengthOfRemarks - enteredCharsLength}</span>
            </div> : undefined
    );
}